import EventHub from '@/utils/EventHub'

import API from '@/mixins/API.js'

export default
{
    name: 'page',

    mixins: [API],

    data()
    {
        return {
            content: null,
            isMobile: false,
            notLoaded: false,
            loadedContent: false
        }
    },

    created()
    {
        EventHub.$on('window:resize', this.onResize)
    },

    mounted()
    {
        this.onResize({width: window.innerWidth, height: window.innerHeight})
    },

    beforeRouteUpdate (to, from, next) {
        if(from.name === to.name && !(from.path === to.path))
        {
            EventHub.$emit('page:transition-in', from, to)
            window.setTimeout(() => {
                next()
            }, 1200)
        }
    },

    beforeRouteLeave (to, from, next) {
        if(!(from.name === to.name))
        {
            EventHub.$emit('page:transition-in', from, to)
            window.setTimeout(() => {
                next()
            }, 1200)
        }
    },

    destroyed()
    {
        EventHub.$off('window:resize', this.onResize)
    },

    methods: {
        loadDatas(endpoint, callback)
        {

            this.fetchUrl(endpoint, (res) => {

                if(callback)
                {
                    callback(res)
                }
            })
        },

        onResize(windowObj)
        {
            if(windowObj.width <= 768)
            {
                this.isMobile = true
            }
            else
            {
                this.isMobile = false
            }
        },

        onLoadedDatas()
        {
            this.loadedContent = true

            this.$nextTick(() => {
                this.onMounted()
            })

        },

        onMounted()
        {
            if(!this.$root.firstPage)
            {
                EventHub.$emit('page:transition-out')
            }
            else
            {
                EventHub.$emit('app:preloading-end')
            }
        },
    }
}
